import React from 'react';
import { IconProps } from '../types/types';

const EURNOK: React.FC<IconProps> = (props) => (
    <svg viewBox="0 0 41 42" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" {...props}>
        <path d="M13.027 0v26.05c7.194 0 13.026-5.83 13.026-13.024C26.053 5.832 20.221 0 13.027 0Z" fill="#214391" />
        <path d="M13.025 0C5.832 0 0 5.832 0 13.026s5.832 13.025 13.025 13.025c7.194 0 7.194-26.05 0-26.05Z" fill="#2B479D" />
        <path
            d="m13.002 2.259.318.978h1.028l-.832.604.318.978-.832-.605-.831.605.317-.978-.832-.604h1.029l.317-.978ZM13.002 20.716l.318.979h1.028l-.832.604.318.977-.832-.604-.831.604.317-.977-.832-.604h1.029l.317-.979ZM18.069 3.895l.317.978h1.028l-.832.604.318.978-.831-.605-.832.605.317-.978-.831-.604h1.028l.317-.978ZM21.526 7.305l.317.977h1.029l-.832.605.318.978-.832-.605-.832.605.318-.978-.832-.605h1.028l.318-.977ZM21.61 15.92l.317.978h1.029l-.832.604.318.978-.832-.604-.832.604.318-.978-.832-.604h1.028l.318-.978ZM4.608 7.305l.317.977h1.028l-.831.605.317.978-.831-.605-.832.605.317-.978-.831-.605H4.29l.318-.977ZM22.326 11.414l.318.977h1.028l-.832.604.318.979-.832-.605-.831.604.318-.978-.832-.604h1.028l.317-.977ZM3.82 11.414l.318.977h1.028l-.832.604.318.979-.831-.605-.832.604.318-.978-.832-.604h1.028l.318-.977ZM4.494 15.92l.318.978H5.84l-.832.604.318.978-.832-.604-.831.604.317-.978-.832-.604h1.029l.317-.978ZM18.217 19.476l.318.977h1.028l-.832.605.318.978-.832-.605-.832.605.318-.978-.832-.605H17.9l.318-.977ZM8.102 3.895l.317.978h1.029l-.832.604.318.978-.832-.605-.832.605.318-.978-.832-.604h1.028l.318-.978ZM7.729 19.413l.317.978h1.029l-.832.604.318.978-.832-.604-.832.604.318-.978-.832-.604H7.41l.318-.978Z"
            fill="#F8D12E"
        />
        <circle cx={26.331} cy={27.331} r={13.581} fill="#fff" stroke="#fff" strokeWidth={0.5} />
        <mask
            id="eurnok_svg__a"
            style={{
                maskType: 'alpha'
            }}
            maskUnits="userSpaceOnUse"
            x={12}
            y={14}
            width={27}
            height={27}
        >
            <path d="M25.33 40.66c7.362 0 13.33-5.968 13.33-13.33S32.692 14 25.33 14 12 19.968 12 27.33s5.968 13.33 13.33 13.33Z" fill="#F0F0F0" />
        </mask>
        <g mask="url(#eurnok_svg__a)">
            <path d="M44.618 13H5v29h39.618V13Z" fill="#EF2B2D" />
            <path d="M44.822 23.853H23.131V13h-7.278v10.853H5v7.31h10.853v10.821h7.278V31.162h21.691v-7.309Z" fill="#fff" />
            <path d="M44.822 25.626H21.296V13H17.75v12.626H5v3.623h12.751v12.547h3.545V29.25h23.526v-3.623Z" fill="#002868" />
        </g>
    </svg>
);

export default EURNOK;
